/* eslint-disable */
import React from "react";
import "contents/assets/scss/page/statistics.scss";

//chart
import LineChart from "../../component/Inc/LineChart";
import Paging from "../../component/Inc/Paging";

function JoinAndLeave() {
  const lineChartWidth = "100%";
  const lineChartHeight = "200px";

  //Linechartlabels
  const lineChartlabels = [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월",
  ];

  //subject card data
  const subjectCardData = [
    { title: "국어(656)", values: ["55", "-12", "17%"] },
    { title: "영어(3145)", values: ["55", "-38", "65%"] },
    { title: "수학(687)", values: ["55", "-12", "32%"] },
    { title: "과탐(324)", values: ["55", "-12", "17%"] },
    { title: "사탐(654)", values: ["55", "-75", "11%"] },
    { title: "수시(332)", values: ["55", "-12", "17%"] },
  ];

  //line chart data
  const lineChartData = {
    lineChartlabels,
    datasets: [
      {
        label: "입사자",
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#fc8019",
      },
      {
        label: "퇴사자",
        data: [1, 4, 5, 2, 5, 9, 7, 6, 6, 1, 8, 5],
        fill: false,
        borderColor: "#d1cdca",
        borderWidth: 1,
        backgroundColor: "#3780ff",
      },
    ],
  };

  return (
    <main className="com_container com_statistics p_join_and_leave">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_5">교사 입사 / 퇴사자 통계</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
              </div>
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <span className="divider"> ~ </span>
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <hr className="com_divider" />
            <section className="wrapper">
              <div className="subject_stats">
                <div className="status_label">
                  <div className="label">입사자</div>
                  <div className="label">퇴사자</div>
                  <div className="label">유지율</div>
                </div>
                {subjectCardData.map((subject, index) => (
                  <div
                    key={index}
                    className={`subject_card ${index === 2 ? "active" : ""}`}
                  >
                    <div
                      className={`subject_title subject_label ${
                        index === 2 ? "active" : ""
                      }`}
                    >
                      {subject.title}
                    </div>
                    {subject.values.map((value, idx) => (
                      <div
                        key={idx}
                        className={`subject_values ${
                          index === 2 && idx === 1 ? "value-active" : ""
                        } ${index === 2 ? "active" : ""}`}
                      >
                        {value}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <hr className="hori_divider" />

              <div className="status_wrap">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력해 주세요."
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
                <div className="item lightOrange">
                  <p className="tit">전체 교사 수</p>
                  <p className="num">32156</p>
                </div>
                <div className="item lightBlue">
                  <p className="tit">전체 입사자</p>
                  <p className="num">32156</p>
                </div>
                <div className="item lightBlue">
                  <p className="tit">전체 퇴사자</p>
                  <p className="num">32156</p>
                </div>
              </div>
            </section>
            <hr className="com_divider" />
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="chart_item">
                    <span className="chart_name_label">입사자</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">퇴사자</span>
                    <div className="chart_slider chart_blue"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart
                    data={lineChartData}
                    width={lineChartWidth}
                    height={lineChartHeight}
                  />
                </div>
              </div>
            </div>

            <div className="com_table_wrap">
              <div className="detail_tit dot">퇴사자 목록</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                </colgroup>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>이름</th>
                    <th>연락처</th>
                    <th>과목</th>
                    <th>시수</th>
                    <th>면접평가</th>
                    <th>시강평가</th>
                    <th>교육수료</th>
                    <th>수업배정</th>
                    <th>입사일</th>
                    <th>퇴사일</th>
                    <th>구분</th>
                    <th>등록자</th>
                    <th>퇴사사유</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>35</td>
                    <td>홍학생103</td>
                    <td>010-1234-1234</td>
                    <td>수학</td>
                    <td>40,000</td>
                    <td>38</td>
                    <td>50</td>
                    <td>○</td>
                    <td>2T</td>
                    <td>2022, 08, 20</td>
                    <td>2023, 01, 05</td>
                    <td>파트</td>
                    <td>김담임103</td>
                    <td>배정거부, 연락두절</td>
                  </tr>
                  <tr>
                    <td>34</td>
                    <td>홍학생103</td>
                    <td>010-1234-1234</td>
                    <td>수학</td>
                    <td>40,000</td>
                    <td>38</td>
                    <td>50</td>
                    <td>○</td>
                    <td>×</td>
                    <td>2022, 08, 20</td>
                    <td>2023, 01, 05</td>
                    <td>전임</td>
                    <td>김담임103</td>
                    <td>배정거부</td>
                  </tr>
                  <tr>
                    <td>33</td>
                    <td>홍학생103</td>
                    <td>010-1234-1234</td>
                    <td>수학</td>
                    <td>40,000</td>
                    <td>38</td>
                    <td>50</td>
                    <td>×</td>
                    <td>4T</td>
                    <td>2022, 08, 20</td>
                    <td>2023, 01, 05</td>
                    <td>파트</td>
                    <td>김담임103</td>
                    <td>개인사정</td>
                  </tr>
                  <tr>
                    <td>32</td>
                    <td>홍학생103</td>
                    <td>010-1234-1234</td>
                    <td>수학</td>
                    <td>40,000</td>
                    <td>38</td>
                    <td>50</td>
                    <td>×</td>
                    <td>×</td>
                    <td>2022, 08, 20</td>
                    <td>2023, 01, 05</td>
                    <td>파트</td>
                    <td>김담임103</td>
                    <td>배정거부, 연락두절</td>
                  </tr>
                  <tr>
                    <td>31</td>
                    <td>홍학생103</td>
                    <td>010-1234-1234</td>
                    <td>수학</td>
                    <td>40,000</td>
                    <td>38</td>
                    <td>50</td>
                    <td>○</td>
                    <td>4T</td>
                    <td>2022, 08, 20</td>
                    <td>2023, 01, 05</td>
                    <td>파트</td>
                    <td>김담임103</td>
                    <td>배정거부, 연락두절</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="com_table_wrap">
              <div className="detail_tit dot">입사자 목록</div>
              <table className="com_board_list">
                <colgroup>
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                  <col width="{{ width: 'calc(100% / 14)' }}" />
                </colgroup>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>컨택자</th>
                    <th>면접자</th>
                    <th>소개자</th>
                    <th>영역</th>
                    <th>입사자</th>
                    <th>나이/성별</th>
                    <th>지역</th>
                    <th>학력</th>
                    <th>구분</th>
                    <th>가능(T)</th>
                    <th>등급</th>
                    <th>구분</th>
                    <th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>35</td>
                    <td>홍학생103</td>
                    <td>김면접105</td>
                    <td>김소개103</td>
                    <td>수학</td>
                    <td>김합격103</td>
                    <td>41/여</td>
                    <td>인천시</td>
                    <td>금오공대 고분자</td>
                    <td>신규</td>
                    <td>10T</td>
                    <td>B-</td>
                    <td>파트</td>
                    <td>중등부 전임교사</td>
                  </tr>
                  <tr>
                    <td>34</td>
                    <td>홍학생103</td>
                    <td>김면접105</td>
                    <td>김소개103</td>
                    <td>수학</td>
                    <td>김합격103</td>
                    <td>40/남</td>
                    <td>남양주</td>
                    <td>금오공대 고분자</td>
                    <td>신규</td>
                    <td>10T</td>
                    <td>B</td>
                    <td>전임</td>
                    <td>시강,경력우수 / 우수자원</td>
                  </tr>
                  <tr>
                    <td>33</td>
                    <td>홍학생103</td>
                    <td>김면접105</td>
                    <td>김소개103</td>
                    <td>수학</td>
                    <td>김합격103</td>
                    <td>41/여</td>
                    <td>인천시</td>
                    <td>금오공대 고분자</td>
                    <td>신규</td>
                    <td>10T</td>
                    <td>C-</td>
                    <td>파트</td>
                    <td>실력은 우수하나 경력 부족</td>
                  </tr>
                  <tr>
                    <td>32</td>
                    <td>홍학생103</td>
                    <td>김면접105</td>
                    <td>김소개103</td>
                    <td>수학</td>
                    <td>김합격103</td>
                    <td>41/여</td>
                    <td>인천시</td>
                    <td>금오공대 고분자</td>
                    <td>신규</td>
                    <td>10T</td>
                    <td>B-</td>
                    <td>파트</td>
                    <td>실력 우수 / 사례평가 저조</td>
                  </tr>
                  <tr>
                    <td>31</td>
                    <td>홍학생103</td>
                    <td>김면접105</td>
                    <td>김소개103</td>
                    <td>수학</td>
                    <td>김합격103</td>
                    <td>41/여</td>
                    <td>인천시</td>
                    <td>금오공대 고분자</td>
                    <td>신규</td>
                    <td>10T</td>
                    <td>B-</td>
                    <td>파트</td>
                    <td>중등부 전임교사</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Paging />
          </div>
        </section>
      </div>
    </main>
  );
}

export default JoinAndLeave;
